export default {"src":"/_next/static/media/deco_rewardCalendar_confetti.7325000b.svg","height":105,"width":295,"blurWidth":0,"blurHeight":0};